{
  "0_ALREADY_EXISTS": "\"{0}\" već postoji.",
  "0_OF_1": "{0} od {1}",
  "ACCOUNT_ID": "ID naloga",
  "ADD": "Dodati",
  "ADD_REMOVE_FIELDS": "Dodaj/ukloni polja",
  "AN_ERROR_OCCURED": "Došlo je do greške",
  "APPLY": "Primenite",
  "APPLY_CHANGES": "Primeni izmene",
  "ATTACH": "Priložite",
  "ATTACH_AS_LINK": "Priloži kao vezu",
  "ATTACHING": "Prilaganje...",
  "AUTOMATICALLY_RENAME": "Automatski preimenuj",
  "BACK": "Povratak",
  "BROWSE": "Potraži",
  "CANCEL": "Otkaži",
  "CHARACTER_COUNT": "Broj znakova:",
  "CLOSE": "Zatvorite",
  "CLOUD": "Oblak",
  "COMMENT": "Komentar",
  "CONFIGURE_REPOSITORY_SETTINGS": "Konfiguriši podešavanje spremišta",
  "COULD_NOT_SAVE_0": "Nije mogao spasiti \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "Nije mogao spasiti \"{0}\". Tip datoteke nije podržan.",
  "DATA": "Podataka",
  "DATE": "Datum",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Polja datuma moraju biti u formatu {0}.",
  "DATE_PROVIDED_IS_INVALID": "Navedeni datum je nevažeći.",
  "DATE_TIME": "Datum / Vreme",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Polja datuma / vremena moraju biti u formatu {0}.",
  "DEFAULT_FOLDER": "<Podrazumevana Fascikla>",
  "DETAILS": "Detalje",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Da li želite da primenite promene u polju?",
  "DOCUMENT_NAME_IS_EMPTY": "Ime dokumenta je prazno",
  "DRAG_DROP_FILE": "Prevuci i ispusti datoteku",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "Unos pod nazivom '{0}' već postoji u ovom folderu. Molimo Vas da izaberete drugo ime.",
  "ENTRY_ID": "Ulazak ID",
  "ENTRY_NAME": "Ime unosa",
  "ENTRY_NOT_FOUND": "Unos nije pronađen.",
  "ERROR_DOWNLOADING_DOCUMENT": "Greška pri preuzimanju dokumenta.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Došlo je do greške prilikom povezivanja sa serverom.",
  "ERROR_SAVING": "Greška u čuvanju:",
  "FAILED_TO_OPEN_FOLDER": "Failed to open folder",
  "FAILED_TO_SAVE_COLON": "Nije uspelo da sačuvate:",
  "FAILED_TO_SAVE_PERIOD": "Nije uspeo da sačuva.",
  "FEEDBACK": "Povratne informacije",
  "FIELDS": "Polja",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Ovaj fajl prelazi maksimalnu veličinu datoteke od 25MB.",
  "FILE_EXTENSION": "Ekstenzija datoteke",
  "FILE_LOCKED": "Fajl je zaključan.",
  "FILE_MODIFIED": "Fajl modifikovan",
  "FILE_NAME": "Ime i prezime",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Imena fajlova ne mogu da sadrže obrnutu kosu crtu",
  "FOLDER": "Fascikle",
  "INTEGER": "Celobrojni",
  "LIST": "Liste",
  "LOADING": "Učitavanje...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Duga polja moraju biti celi brojevi između 0 i 3,999,999,999",
  "LONG_INTEGER": "Dugi ceo broj",
  "NAME": "Ime",
  "NAME_CONFLICT": "Sukob imena",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Potrebna vam je pomoć pri prijavljivanju? Obratite se administratoru Laserfiche za pomoć.",
  "NEW_FOLDER": "Nova fascikla",
  "NO": "Ne",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Nema dodatnih polja dodeljenih",
  "NO_FOLDER_SELECTED": "Nijedna fascikla nije izabrana.",
  "NO_MATCHING_ENTRIES_FOUND": "Nisu pronađeni odgovarajući unosi",
  "NO_MATCHING_FIELDS_FOUND": "Nisu pronađena odgovarajuća polja.",
  "NO_TEMPLATE_ASSIGNED": "Nije dodeljen šablon",
  "NOT_AVAILABLE_WITH_TOKENS": "Nije dostupno sa tokenima",
  "NUMBER": "Broj",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Polje broja mora biti važeći broj",
  "OK": "U redu",
  "ONE_OR_MORE_FIELDS_INVALID": "Jedno ili više polja su nevažeća.",
  "OPEN": "Otvorite",
  "OPEN_IN_LASERFICHE": "Otvoreno u Laserfiche",
  "OPTIONAL": "Opcionalno",
  "OR": "Ili",
  "PARENT_FIELD": "Roditeljsko polje",
  "PARENT_ID": "ID roditelja",
  "PARENT_NAME": "Ime roditelja",
  "PLEASE_SELECT_A_FOLDER": "Molimo Vas da izaberete fasciklu",
  "REASON_FOR_DOWNLOADING": "Razlog za preuzimanje",
  "REFRESH": "Osveži",
  "REMOVE": "Uklonite",
  "REMOVE_REPOSITORY": "Ukloniti spremište?",
  "REPOSITORY": "Izvora",
  "REPOSITORY_COUNT": "Broj spremišta",
  "REPOSITORY_ID": "ID spremišta",
  "REPOSITORY_NAME": "Ime spremišta",
  "REQUIRED": "Potrebne",
  "REQUIRED_FIELD_IS_EMPTY": "Obavezno polje je prazno",
  "SAVE_CHANGES": "Sačuvaj izmene",
  "SAVE_TO_LASERFICHE": "Sačuvaj u Laserfiche",
  "SAVED_TO_LASERFICHE": "Sačuvano u Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "Sačuvano u Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "Sačuvano sa nedostajućim metapodacima:",
  "SAVING": "Čuvanje...",
  "SEARCH_FIELDS": "Polja za pretragu",
  "SELECT": "Izaberite",
  "SELECT_REASON": "Izaberite razlog",
  "SELF_HOSTED": "Samostalni domaćin",
  "SESSION_COUNT": "Broj sesija",
  "SETTINGS": "Postavke",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Kratka polja moraju biti celi brojevi između 0 i 64999",
  "SIGN_IN": "Upiši se",
  "SIGN_IN_TO_LASERFICHE": "Prijavite se na Laserfiche",
  "SIGN_OUT": "Odjava",
  "SIGNING_IN": "Prijavljivanje ...",
  "SIGNING_OUT": "Odjavljivanje ...",
  "SKIP_THIS_FILE": "Preskoči ovaj fajl",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Nešto je pošlo naopako. Pokušajte ponovo kasnije.",
  "SUBMIT": "Prosleđivanje",
  "SUGGESTION": "Predlog",
  "TEMPLATE": "Predložak",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "Šablon nije uspeo da se učita.",
  "TEXT": "Tekstualna poruka",
  "THANK_YOU_FOR_SUBMISSION": "Hvala vam na podnošenju!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Ovo polje ima maksimalnu dozvoljenu dužinu od {0} Znakova.",
  "THIS_FOLDER_IS_EMPTY": "Ova fascikla je prazna.",
  "TIME": "Vreme",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Vremenska polja moraju biti u formatu {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Nije moguće učitati sva polja:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Nemogućnost da se preuzme informacije o spremištu:",
  "UNKNOWN_ERROR": "Nepoznata greška.",
  "USER_NAME": "Korisničko ime",
  "YES": "Da"
}
